import { PublicEvents } from "../types/Events.types";
import { processEvent } from "../services/processEvent.service";
;
/**
 * Analytics Api: internalVideoEvent.
 * @param {object} InternalVideoEventParams Object with the internal video event details.
 * @param {string} InternalVideoEventParams.videoId Id for the video
 * @param {string} InternalVideoEventParams.videoName Name of the video
 * @param {string} InternalVideoEventParams.videoTitle Title of the video
 * @param {string} InternalVideoEventParams.videoAction Event action
 * @param {object} [customPayload] An optional payload that may be provided to send additional data with the event.
 *
 * @example
 * import { internalVideoEvent } from "@octagon/public-analytics";
 *
 * // With NO additional payload data
 * internalVideoEvent({
 *   videoId: "d482155a-4bf4-4316-a2fc-8ffcfe0f966f",
 *   videoName: "free-credit-score-manage",
 *   videoTitle: "Check Your Credit Score for Free with Credit Journey | Chase",
 *   videoAction: "videoPlay"
 * });
 *
 * // With additional payload data
 * internalVideoEvent(
 *   {
 *   videoId: "d482155a-4bf4-4316-a2fc-8ffcfe0f966f",
 *   videoName: "free-credit-score-manage",
 *   videoTitle: "Check Your Credit Score for Free with Credit Journey | Chase",
 *   videoAction: "videoPlay"
 *   },
 *   { devSpecifiedData: "1625254612928" }
 * );
 *
 * @category Events
 */
export function internalVideoEvent(params, customPayload) {
    if (customPayload === void 0) { customPayload = {}; }
    processEvent(PublicEvents.INTERNAL_VIDEO, params, customPayload);
}
